import {post,get} from '../../libs/ajax.js'

export default {

    /* 列表相关接口 */

    //  批量创建-列表-目标账户下拉选项
    getAccountSearchList:(data,options) => {
        return get('/mi/batch/v2/get_select_account', data, options);
    },
    //  批量创建-列表-产品下拉选项
    getAppSearchList:(data,options) => {
        return get('/mi/batch/v2/get_select_app', data, options);
    },
    //  批量创建-列表-创建人下拉选项
    getCreatorSearchList:(data,options) => {
        return get('/mi/batch/v2/get_select_user', data, options);
    },
    //  批量创建-列表-创建部门下拉选项
    getDepartmentSearchList:(data,options) => {
        return get('/mi/batch/v2/get_select_department', data, options);
    },
    //  批量创建-列表-列表汇总数据
    getTotalData:(data,options) => {
        return get('/mi/batch/v2/get_total', data, options);
    },
    //  批量创建-列表-列表数据
    getDataList:(data,options) => {
        return get('/mi/batch/v2/get_list', data, options);
    },
    //  批量创建-列表详情页-列表数据
    getDetailDataList:(data,options) => {
        return get('/mi/batch/v2/get_detail_list', data, options);
    },
    // 批量创建-列表详情页-目标账户与产品&汇总数据
    getDetailDataAccountAppInfo:(data,options) => {
        return get('/mi/batch/v2/get_detail_info', data, options);
    },
    // 批量创建-列表页-获取能够重试任务的用户列表
    getRetryUserList:(data,options) => {
        return get('/mi/batch/v2/get_retry_user', data, options);
    },
    // 批量创建-任务重试
    retryTask:(data,options) => {
        return post('/mi/batch/v2/task_retry', data, options);
    },
     // 批量创建-获取渠道包
    getChannelNameList:(data,options) => {
        return get('/mi/batch/v2/get_channel_name_list', data, options);
    },


    /* 创建相关接口 */

    // 获取目标账户
    getAccountDataList:(data,options) => {
        return get('/mi/batch/v2/get_account_list', data, options);
    },
    // 获取产品列表
    getAppDataList:(data,options) => {
        return get('/mi/batch/v2/get_app_list', data, options);
    },
     // 获取配置选项
     getConfigDataList:(data,options) => {
        return get('/mi/batch/v2/get_config', data, options);
    },
    // 获取定向人群
    getUserPackageDataList:(data,options) => {
        return get('/mi/batch/v2/get_user_package_list', data, options);
    },
    // 更新定向人群
    postUpdateUserPackageDataList:(data,options) => {
        return post('/mi/batch/v2/update_user_package_list', data, options);
    },
    // 转化出价 - 获取对应 投放范围-版位 的跟踪类型、转化类型、转化名称
    getConversionDataList:(data,options) => {
        return get('/mi/batch/v2/get_conversion_list', data, options);
    },
     // 获取转化名称
     getConversionNameDataList:(data,options) => {
        return get('/mi/batch/v2/get_conversion_name_list', data, options);
    },
    // 转化出价 - 添加转化名称
    addConversionData:(data,options) => {
        return post('/mi/batch/v2/add_conversion', data, options);
    },
    // 生成预览
    postBatchPreview:(data,options) => {
        return post('/mi/batch/v2/preview', data, options);
    },
    // 修改广告信息
    postModifyInfo:(data,options) => {
        return post('/mi/batch/v2/modify_info', data, options);
    },
    // 去除特殊字符
    postDelSpecialCharacter:(data,options) => {
        return post('/mi/batch/v2/del_special_character', data, options);
    },
    // 获取任务配置
    getTaskInfoDataList:(data,options) => {
        return get('/mi/batch/v2/get_task_info', data, options);
    },
     // 获取转化出价均值
     getConversionPriceDataList:(data,options) => {
        return get('/mi/batch/v2/get_conversion_price', data, options);
    },
    //更新转化名称列表
    postUpdateConversion:(data,options) => {
        return post('/mi/batch/v2/update_conversion', data, options);
    },
     //批量获取转化名称
    batchConversionName:(data,options) => {
        return post('/mi/batch/v2/batch_get_conversion_name', data, options);
    },



    //创意组 - 获取素材规格对应的素材尺寸信息
    getMiMaterialInfo:(data,options) => {
        return get('/mi/batch/v2/get_material_info', data, options);
    },
    //创意组 - 获取工单素材
    postMiWorkOrderList:(data,options) => {
        return post('/mi/batch/v2/get_work_order_material_list', data, options);
    },
    //创意组 - 视频自动生成封面
    postMiVideoFirstImg:(data,options) => {
        return post('/mi/batch/v2/gen_video_cover_img', data, options);
    },
    // 预览-详情列表(点击生成预览后)
    getBatchPreviewList:(data,options) => {
        return get('/mi/batch/v2/preview_list', data, options);
    },
    // 预览-目标账户与产品(点击生成预览后)
    getBatchPreviewInfo:(data,options) => {
        return get('/mi/batch/v2/preview_info', data, options);
    },
    // 提交创建
    saveBatchTask:(data,options) => {
        return post('/mi/batch/v2/save', data, options);
    },
     // 搜索配置
     getWorkOrderSearchConfig(data,options){
        return get('/mi/batch/v2/get_work_order_search_config',data,options);
    },
}


